module.exports = __webpack_public_path__ + "img/logo_alicloud.eea23492.png";